import { PumpEntity } from '../pump/pump'
import { ShiftEntity } from '../shift/shift'
import { UserEntity } from '../user/user'

export enum PumpShiftStatusEnum {
  CLOSED = 'CLOSED',
  UNCLOSE = 'UNCLOSE',
  WORKING = 'WORKING',
  FUTURE = 'FUTURE',
}

export type PumpShiftEntity = {
  id: number
  createdDate: number
  closedTime: number
  shift: ShiftEntity
  pump: PumpEntity
  totalVolume: number
  totalAmount: number
  executor: UserEntity
}

export type PumpShiftFilter = {
  createdDateFrom?: number
  createdDateTo?: number
  closedTimeFrom?: number
  closedTimeTo?: number
  statuses: PumpShiftStatusEnum[]
  stationName: string
  stationIds: number[]
  shiftName: string
  pumpName: string
  pageSize: number
  pageIndex: number
}
